/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAppointmentsRouteImport } from './routes/_authenticated/appointments'
import { Route as AuthenticatedCallHistoryRouteImport } from './routes/_authenticated/call-history'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedFindSlotsRouteImport } from './routes/_authenticated/find-slots'
import { Route as AuthenticatedLiveCallsRouteImport } from './routes/_authenticated/live-calls'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedVerifyPasskeyRouteImport } from './routes/_authenticated/verify-passkey'
import { Route as AuthenticatedWaitlistRouteImport } from './routes/_authenticated/waitlist'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PlatformAdminUsersRouteImport } from './routes/platform/admin-users'
import { Route as PlatformOrganizationsRouteImport } from './routes/platform/organizations'
import { Route as AuthenticatedActivityIndexRouteImport } from './routes/_authenticated/activity/index'
import { Route as AuthenticatedActivityInteractionIdRouteImport } from './routes/_authenticated/activity/$interactionId'
import { Route as AuthenticatedCallsIndexRouteImport } from './routes/_authenticated/calls/index'
import { Route as AuthenticatedCallsLiveRouteImport } from './routes/_authenticated/calls/live'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns/index'
import { Route as AuthenticatedCampaignsNewRouteImport } from './routes/_authenticated/campaigns/new'
import { Route as AuthenticatedCampaignsRulesRouteImport } from './routes/_authenticated/campaigns/rules'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedDocumentsIdRouteImport } from './routes/_authenticated/documents/$id'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated/patients/index'
import { Route as AuthenticatedPatientsIdRouteImport } from './routes/_authenticated/patients/$id'
import { Route as AuthenticatedReferralsIndexRouteImport } from './routes/_authenticated/referrals/index'
import { Route as AuthenticatedSetupAppointmentTypesRouteImport } from './routes/_authenticated/setup/appointment-types'
import { Route as AuthenticatedSetupAssignmentRulesRouteImport } from './routes/_authenticated/setup/assignment-rules'
import { Route as AuthenticatedSetupEntitiesRouteImport } from './routes/_authenticated/setup/entities'
import { Route as AuthenticatedSetupIntegrationsRouteImport } from './routes/_authenticated/setup/integrations'
import { Route as AuthenticatedSetupLabelsRouteImport } from './routes/_authenticated/setup/labels'
import { Route as AuthenticatedSetupLocationsRouteImport } from './routes/_authenticated/setup/locations'
import { Route as AuthenticatedSetupOrganizationRouteImport } from './routes/_authenticated/setup/organization'
import { Route as AuthenticatedSetupOutreachRouteImport } from './routes/_authenticated/setup/outreach'
import { Route as AuthenticatedSetupPayorsRouteImport } from './routes/_authenticated/setup/payors'
import { Route as AuthenticatedSetupProvidersRouteImport } from './routes/_authenticated/setup/providers'
import { Route as AuthenticatedSetupRolesRouteImport } from './routes/_authenticated/setup/roles'
import { Route as AuthenticatedSetupTeamsRouteImport } from './routes/_authenticated/setup/teams'
import { Route as AuthenticatedSetupUsersRouteImport } from './routes/_authenticated/setup/users'
import { Route as AuthenticatedSetupWorkflowsRouteImport } from './routes/_authenticated/setup/workflows'
import { Route as AuthenticatedSmsTestRouteImport } from './routes/_authenticated/sms/test'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedTasksTaskIdRouteImport } from './routes/_authenticated/tasks/$taskId'
import { Route as AuthenticatedCampaignsIdIndexRouteImport } from './routes/_authenticated/campaigns/$id/index'
import { Route as AuthenticatedCampaignsIdEditRouteImport } from './routes/_authenticated/campaigns/$id/edit'
import { Route as AuthenticatedPatientsIdTabRouteImport } from './routes/_authenticated/patients/$id/$tab'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppointmentsRoute =
  AuthenticatedAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallHistoryRoute =
  AuthenticatedCallHistoryRouteImport.update({
    id: '/call-history',
    path: '/call-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFindSlotsRoute = AuthenticatedFindSlotsRouteImport.update({
  id: '/find-slots',
  path: '/find-slots',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLiveCallsRoute = AuthenticatedLiveCallsRouteImport.update({
  id: '/live-calls',
  path: '/live-calls',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVerifyPasskeyRoute =
  AuthenticatedVerifyPasskeyRouteImport.update({
    id: '/verify-passkey',
    path: '/verify-passkey',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWaitlistRoute = AuthenticatedWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PlatformAdminUsersRoute = PlatformAdminUsersRouteImport.update({
  id: '/admin-users',
  path: '/admin-users',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformOrganizationsRoute = PlatformOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => PlatformRoute,
} as any)
const AuthenticatedActivityIndexRoute =
  AuthenticatedActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivityInteractionIdRoute =
  AuthenticatedActivityInteractionIdRouteImport.update({
    id: '/activity/$interactionId',
    path: '/activity/$interactionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallsIndexRoute = AuthenticatedCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCallsLiveRoute = AuthenticatedCallsLiveRouteImport.update({
  id: '/calls/live',
  path: '/calls/live',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsNewRoute =
  AuthenticatedCampaignsNewRouteImport.update({
    id: '/campaigns/new',
    path: '/campaigns/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsRulesRoute =
  AuthenticatedCampaignsRulesRouteImport.update({
    id: '/campaigns/rules',
    path: '/campaigns/rules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsIdRoute =
  AuthenticatedDocumentsIdRouteImport.update({
    id: '/documents/$id',
    path: '/documents/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIdRoute = AuthenticatedPatientsIdRouteImport.update({
  id: '/patients/$id',
  path: '/patients/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReferralsIndexRoute =
  AuthenticatedReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSetupAppointmentTypesRoute =
  AuthenticatedSetupAppointmentTypesRouteImport.update({
    id: '/appointment-types',
    path: '/appointment-types',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupAssignmentRulesRoute =
  AuthenticatedSetupAssignmentRulesRouteImport.update({
    id: '/assignment-rules',
    path: '/assignment-rules',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupEntitiesRoute =
  AuthenticatedSetupEntitiesRouteImport.update({
    id: '/entities',
    path: '/entities',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupIntegrationsRoute =
  AuthenticatedSetupIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupLabelsRoute =
  AuthenticatedSetupLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupLocationsRoute =
  AuthenticatedSetupLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupOrganizationRoute =
  AuthenticatedSetupOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupOutreachRoute =
  AuthenticatedSetupOutreachRouteImport.update({
    id: '/outreach',
    path: '/outreach',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupPayorsRoute =
  AuthenticatedSetupPayorsRouteImport.update({
    id: '/payors',
    path: '/payors',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupProvidersRoute =
  AuthenticatedSetupProvidersRouteImport.update({
    id: '/providers',
    path: '/providers',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupRolesRoute = AuthenticatedSetupRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const AuthenticatedSetupTeamsRoute = AuthenticatedSetupTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const AuthenticatedSetupUsersRoute = AuthenticatedSetupUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const AuthenticatedSetupWorkflowsRoute =
  AuthenticatedSetupWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSmsTestRoute = AuthenticatedSmsTestRouteImport.update({
  id: '/sms/test',
  path: '/sms/test',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksTaskIdRoute =
  AuthenticatedTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsIdIndexRoute =
  AuthenticatedCampaignsIdIndexRouteImport.update({
    id: '/campaigns/$id/',
    path: '/campaigns/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsIdEditRoute =
  AuthenticatedCampaignsIdEditRouteImport.update({
    id: '/campaigns/$id/edit',
    path: '/campaigns/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIdTabRoute =
  AuthenticatedPatientsIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => AuthenticatedPatientsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/platform': typeof PlatformRouteWithChildren
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/call-history': typeof AuthenticatedCallHistoryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/find-slots': typeof AuthenticatedFindSlotsRoute
  '/live-calls': typeof AuthenticatedLiveCallsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/setup': typeof AuthenticatedSetupRouteWithChildren
  '/verify-passkey': typeof AuthenticatedVerifyPasskeyRoute
  '/waitlist': typeof AuthenticatedWaitlistRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/platform/admin-users': typeof PlatformAdminUsersRoute
  '/platform/organizations': typeof PlatformOrganizationsRoute
  '/activity/$interactionId': typeof AuthenticatedActivityInteractionIdRoute
  '/calls/live': typeof AuthenticatedCallsLiveRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/campaigns/rules': typeof AuthenticatedCampaignsRulesRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/patients/$id': typeof AuthenticatedPatientsIdRouteWithChildren
  '/setup/appointment-types': typeof AuthenticatedSetupAppointmentTypesRoute
  '/setup/assignment-rules': typeof AuthenticatedSetupAssignmentRulesRoute
  '/setup/entities': typeof AuthenticatedSetupEntitiesRoute
  '/setup/integrations': typeof AuthenticatedSetupIntegrationsRoute
  '/setup/labels': typeof AuthenticatedSetupLabelsRoute
  '/setup/locations': typeof AuthenticatedSetupLocationsRoute
  '/setup/organization': typeof AuthenticatedSetupOrganizationRoute
  '/setup/outreach': typeof AuthenticatedSetupOutreachRoute
  '/setup/payors': typeof AuthenticatedSetupPayorsRoute
  '/setup/providers': typeof AuthenticatedSetupProvidersRoute
  '/setup/roles': typeof AuthenticatedSetupRolesRoute
  '/setup/teams': typeof AuthenticatedSetupTeamsRoute
  '/setup/users': typeof AuthenticatedSetupUsersRoute
  '/setup/workflows': typeof AuthenticatedSetupWorkflowsRoute
  '/sms/test': typeof AuthenticatedSmsTestRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/activity/': typeof AuthenticatedActivityIndexRoute
  '/calls/': typeof AuthenticatedCallsIndexRoute
  '/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/patients/': typeof AuthenticatedPatientsIndexRoute
  '/referrals/': typeof AuthenticatedReferralsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/campaigns/$id/edit': typeof AuthenticatedCampaignsIdEditRoute
  '/patients/$id/$tab': typeof AuthenticatedPatientsIdTabRoute
  '/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/platform': typeof PlatformRouteWithChildren
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/call-history': typeof AuthenticatedCallHistoryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/find-slots': typeof AuthenticatedFindSlotsRoute
  '/live-calls': typeof AuthenticatedLiveCallsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/setup': typeof AuthenticatedSetupRouteWithChildren
  '/verify-passkey': typeof AuthenticatedVerifyPasskeyRoute
  '/waitlist': typeof AuthenticatedWaitlistRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/platform/admin-users': typeof PlatformAdminUsersRoute
  '/platform/organizations': typeof PlatformOrganizationsRoute
  '/activity/$interactionId': typeof AuthenticatedActivityInteractionIdRoute
  '/calls/live': typeof AuthenticatedCallsLiveRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/campaigns/rules': typeof AuthenticatedCampaignsRulesRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/patients/$id': typeof AuthenticatedPatientsIdRouteWithChildren
  '/setup/appointment-types': typeof AuthenticatedSetupAppointmentTypesRoute
  '/setup/assignment-rules': typeof AuthenticatedSetupAssignmentRulesRoute
  '/setup/entities': typeof AuthenticatedSetupEntitiesRoute
  '/setup/integrations': typeof AuthenticatedSetupIntegrationsRoute
  '/setup/labels': typeof AuthenticatedSetupLabelsRoute
  '/setup/locations': typeof AuthenticatedSetupLocationsRoute
  '/setup/organization': typeof AuthenticatedSetupOrganizationRoute
  '/setup/outreach': typeof AuthenticatedSetupOutreachRoute
  '/setup/payors': typeof AuthenticatedSetupPayorsRoute
  '/setup/providers': typeof AuthenticatedSetupProvidersRoute
  '/setup/roles': typeof AuthenticatedSetupRolesRoute
  '/setup/teams': typeof AuthenticatedSetupTeamsRoute
  '/setup/users': typeof AuthenticatedSetupUsersRoute
  '/setup/workflows': typeof AuthenticatedSetupWorkflowsRoute
  '/sms/test': typeof AuthenticatedSmsTestRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/calls': typeof AuthenticatedCallsIndexRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/referrals': typeof AuthenticatedReferralsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/campaigns/$id/edit': typeof AuthenticatedCampaignsIdEditRoute
  '/patients/$id/$tab': typeof AuthenticatedPatientsIdTabRoute
  '/campaigns/$id': typeof AuthenticatedCampaignsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/platform': typeof PlatformRouteWithChildren
  '/_authenticated/appointments': typeof AuthenticatedAppointmentsRoute
  '/_authenticated/call-history': typeof AuthenticatedCallHistoryRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/find-slots': typeof AuthenticatedFindSlotsRoute
  '/_authenticated/live-calls': typeof AuthenticatedLiveCallsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/setup': typeof AuthenticatedSetupRouteWithChildren
  '/_authenticated/verify-passkey': typeof AuthenticatedVerifyPasskeyRoute
  '/_authenticated/waitlist': typeof AuthenticatedWaitlistRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/platform/admin-users': typeof PlatformAdminUsersRoute
  '/platform/organizations': typeof PlatformOrganizationsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/activity/$interactionId': typeof AuthenticatedActivityInteractionIdRoute
  '/_authenticated/calls/live': typeof AuthenticatedCallsLiveRoute
  '/_authenticated/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/_authenticated/campaigns/rules': typeof AuthenticatedCampaignsRulesRoute
  '/_authenticated/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/_authenticated/patients/$id': typeof AuthenticatedPatientsIdRouteWithChildren
  '/_authenticated/setup/appointment-types': typeof AuthenticatedSetupAppointmentTypesRoute
  '/_authenticated/setup/assignment-rules': typeof AuthenticatedSetupAssignmentRulesRoute
  '/_authenticated/setup/entities': typeof AuthenticatedSetupEntitiesRoute
  '/_authenticated/setup/integrations': typeof AuthenticatedSetupIntegrationsRoute
  '/_authenticated/setup/labels': typeof AuthenticatedSetupLabelsRoute
  '/_authenticated/setup/locations': typeof AuthenticatedSetupLocationsRoute
  '/_authenticated/setup/organization': typeof AuthenticatedSetupOrganizationRoute
  '/_authenticated/setup/outreach': typeof AuthenticatedSetupOutreachRoute
  '/_authenticated/setup/payors': typeof AuthenticatedSetupPayorsRoute
  '/_authenticated/setup/providers': typeof AuthenticatedSetupProvidersRoute
  '/_authenticated/setup/roles': typeof AuthenticatedSetupRolesRoute
  '/_authenticated/setup/teams': typeof AuthenticatedSetupTeamsRoute
  '/_authenticated/setup/users': typeof AuthenticatedSetupUsersRoute
  '/_authenticated/setup/workflows': typeof AuthenticatedSetupWorkflowsRoute
  '/_authenticated/sms/test': typeof AuthenticatedSmsTestRoute
  '/_authenticated/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/_authenticated/activity/': typeof AuthenticatedActivityIndexRoute
  '/_authenticated/calls/': typeof AuthenticatedCallsIndexRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/_authenticated/referrals/': typeof AuthenticatedReferralsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/campaigns/$id/edit': typeof AuthenticatedCampaignsIdEditRoute
  '/_authenticated/patients/$id/$tab': typeof AuthenticatedPatientsIdTabRoute
  '/_authenticated/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/complete-profile'
    | '/platform'
    | '/appointments'
    | '/call-history'
    | '/dashboard'
    | '/find-slots'
    | '/live-calls'
    | '/profile'
    | '/setup'
    | '/verify-passkey'
    | '/waitlist'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/platform/admin-users'
    | '/platform/organizations'
    | '/activity/$interactionId'
    | '/calls/live'
    | '/campaigns/new'
    | '/campaigns/rules'
    | '/documents/$id'
    | '/patients/$id'
    | '/setup/appointment-types'
    | '/setup/assignment-rules'
    | '/setup/entities'
    | '/setup/integrations'
    | '/setup/labels'
    | '/setup/locations'
    | '/setup/organization'
    | '/setup/outreach'
    | '/setup/payors'
    | '/setup/providers'
    | '/setup/roles'
    | '/setup/teams'
    | '/setup/users'
    | '/setup/workflows'
    | '/sms/test'
    | '/tasks/$taskId'
    | '/activity/'
    | '/calls/'
    | '/campaigns/'
    | '/documents/'
    | '/patients/'
    | '/referrals/'
    | '/tasks/'
    | '/campaigns/$id/edit'
    | '/patients/$id/$tab'
    | '/campaigns/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/complete-profile'
    | '/platform'
    | '/appointments'
    | '/call-history'
    | '/dashboard'
    | '/find-slots'
    | '/live-calls'
    | '/profile'
    | '/setup'
    | '/verify-passkey'
    | '/waitlist'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/platform/admin-users'
    | '/platform/organizations'
    | '/activity/$interactionId'
    | '/calls/live'
    | '/campaigns/new'
    | '/campaigns/rules'
    | '/documents/$id'
    | '/patients/$id'
    | '/setup/appointment-types'
    | '/setup/assignment-rules'
    | '/setup/entities'
    | '/setup/integrations'
    | '/setup/labels'
    | '/setup/locations'
    | '/setup/organization'
    | '/setup/outreach'
    | '/setup/payors'
    | '/setup/providers'
    | '/setup/roles'
    | '/setup/teams'
    | '/setup/users'
    | '/setup/workflows'
    | '/sms/test'
    | '/tasks/$taskId'
    | '/activity'
    | '/calls'
    | '/campaigns'
    | '/documents'
    | '/patients'
    | '/referrals'
    | '/tasks'
    | '/campaigns/$id/edit'
    | '/patients/$id/$tab'
    | '/campaigns/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/complete-profile'
    | '/platform'
    | '/_authenticated/appointments'
    | '/_authenticated/call-history'
    | '/_authenticated/dashboard'
    | '/_authenticated/find-slots'
    | '/_authenticated/live-calls'
    | '/_authenticated/profile'
    | '/_authenticated/setup'
    | '/_authenticated/verify-passkey'
    | '/_authenticated/waitlist'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/platform/admin-users'
    | '/platform/organizations'
    | '/_authenticated/'
    | '/_authenticated/activity/$interactionId'
    | '/_authenticated/calls/live'
    | '/_authenticated/campaigns/new'
    | '/_authenticated/campaigns/rules'
    | '/_authenticated/documents/$id'
    | '/_authenticated/patients/$id'
    | '/_authenticated/setup/appointment-types'
    | '/_authenticated/setup/assignment-rules'
    | '/_authenticated/setup/entities'
    | '/_authenticated/setup/integrations'
    | '/_authenticated/setup/labels'
    | '/_authenticated/setup/locations'
    | '/_authenticated/setup/organization'
    | '/_authenticated/setup/outreach'
    | '/_authenticated/setup/payors'
    | '/_authenticated/setup/providers'
    | '/_authenticated/setup/roles'
    | '/_authenticated/setup/teams'
    | '/_authenticated/setup/users'
    | '/_authenticated/setup/workflows'
    | '/_authenticated/sms/test'
    | '/_authenticated/tasks/$taskId'
    | '/_authenticated/activity/'
    | '/_authenticated/calls/'
    | '/_authenticated/campaigns/'
    | '/_authenticated/documents/'
    | '/_authenticated/patients/'
    | '/_authenticated/referrals/'
    | '/_authenticated/tasks/'
    | '/_authenticated/campaigns/$id/edit'
    | '/_authenticated/patients/$id/$tab'
    | '/_authenticated/campaigns/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  CompleteProfileRoute: typeof CompleteProfileRoute
  PlatformRoute: typeof PlatformRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments': {
      id: '/_authenticated/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call-history': {
      id: '/_authenticated/call-history'
      path: '/call-history'
      fullPath: '/call-history'
      preLoaderRoute: typeof AuthenticatedCallHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/find-slots': {
      id: '/_authenticated/find-slots'
      path: '/find-slots'
      fullPath: '/find-slots'
      preLoaderRoute: typeof AuthenticatedFindSlotsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-calls': {
      id: '/_authenticated/live-calls'
      path: '/live-calls'
      fullPath: '/live-calls'
      preLoaderRoute: typeof AuthenticatedLiveCallsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup': {
      id: '/_authenticated/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthenticatedSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/verify-passkey': {
      id: '/_authenticated/verify-passkey'
      path: '/verify-passkey'
      fullPath: '/verify-passkey'
      preLoaderRoute: typeof AuthenticatedVerifyPasskeyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/waitlist': {
      id: '/_authenticated/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof AuthenticatedWaitlistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/platform/admin-users': {
      id: '/platform/admin-users'
      path: '/admin-users'
      fullPath: '/platform/admin-users'
      preLoaderRoute: typeof PlatformAdminUsersRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/organizations': {
      id: '/platform/organizations'
      path: '/organizations'
      fullPath: '/platform/organizations'
      preLoaderRoute: typeof PlatformOrganizationsRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/_authenticated/activity/': {
      id: '/_authenticated/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof AuthenticatedActivityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/$interactionId': {
      id: '/_authenticated/activity/$interactionId'
      path: '/activity/$interactionId'
      fullPath: '/activity/$interactionId'
      preLoaderRoute: typeof AuthenticatedActivityInteractionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calls/': {
      id: '/_authenticated/calls/'
      path: '/calls'
      fullPath: '/calls/'
      preLoaderRoute: typeof AuthenticatedCallsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calls/live': {
      id: '/_authenticated/calls/live'
      path: '/calls/live'
      fullPath: '/calls/live'
      preLoaderRoute: typeof AuthenticatedCallsLiveRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/new': {
      id: '/_authenticated/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AuthenticatedCampaignsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/rules': {
      id: '/_authenticated/campaigns/rules'
      path: '/campaigns/rules'
      fullPath: '/campaigns/rules'
      preLoaderRoute: typeof AuthenticatedCampaignsRulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/$id': {
      id: '/_authenticated/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AuthenticatedDocumentsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/$id': {
      id: '/_authenticated/patients/$id'
      path: '/patients/$id'
      fullPath: '/patients/$id'
      preLoaderRoute: typeof AuthenticatedPatientsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/referrals/': {
      id: '/_authenticated/referrals/'
      path: '/referrals'
      fullPath: '/referrals/'
      preLoaderRoute: typeof AuthenticatedReferralsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup/appointment-types': {
      id: '/_authenticated/setup/appointment-types'
      path: '/appointment-types'
      fullPath: '/setup/appointment-types'
      preLoaderRoute: typeof AuthenticatedSetupAppointmentTypesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/assignment-rules': {
      id: '/_authenticated/setup/assignment-rules'
      path: '/assignment-rules'
      fullPath: '/setup/assignment-rules'
      preLoaderRoute: typeof AuthenticatedSetupAssignmentRulesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/entities': {
      id: '/_authenticated/setup/entities'
      path: '/entities'
      fullPath: '/setup/entities'
      preLoaderRoute: typeof AuthenticatedSetupEntitiesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/integrations': {
      id: '/_authenticated/setup/integrations'
      path: '/integrations'
      fullPath: '/setup/integrations'
      preLoaderRoute: typeof AuthenticatedSetupIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/labels': {
      id: '/_authenticated/setup/labels'
      path: '/labels'
      fullPath: '/setup/labels'
      preLoaderRoute: typeof AuthenticatedSetupLabelsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/locations': {
      id: '/_authenticated/setup/locations'
      path: '/locations'
      fullPath: '/setup/locations'
      preLoaderRoute: typeof AuthenticatedSetupLocationsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/organization': {
      id: '/_authenticated/setup/organization'
      path: '/organization'
      fullPath: '/setup/organization'
      preLoaderRoute: typeof AuthenticatedSetupOrganizationRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/outreach': {
      id: '/_authenticated/setup/outreach'
      path: '/outreach'
      fullPath: '/setup/outreach'
      preLoaderRoute: typeof AuthenticatedSetupOutreachRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/payors': {
      id: '/_authenticated/setup/payors'
      path: '/payors'
      fullPath: '/setup/payors'
      preLoaderRoute: typeof AuthenticatedSetupPayorsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/providers': {
      id: '/_authenticated/setup/providers'
      path: '/providers'
      fullPath: '/setup/providers'
      preLoaderRoute: typeof AuthenticatedSetupProvidersRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/roles': {
      id: '/_authenticated/setup/roles'
      path: '/roles'
      fullPath: '/setup/roles'
      preLoaderRoute: typeof AuthenticatedSetupRolesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/teams': {
      id: '/_authenticated/setup/teams'
      path: '/teams'
      fullPath: '/setup/teams'
      preLoaderRoute: typeof AuthenticatedSetupTeamsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/users': {
      id: '/_authenticated/setup/users'
      path: '/users'
      fullPath: '/setup/users'
      preLoaderRoute: typeof AuthenticatedSetupUsersRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/workflows': {
      id: '/_authenticated/setup/workflows'
      path: '/workflows'
      fullPath: '/setup/workflows'
      preLoaderRoute: typeof AuthenticatedSetupWorkflowsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/sms/test': {
      id: '/_authenticated/sms/test'
      path: '/sms/test'
      fullPath: '/sms/test'
      preLoaderRoute: typeof AuthenticatedSmsTestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId': {
      id: '/_authenticated/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/$id/': {
      id: '/_authenticated/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id/'
      preLoaderRoute: typeof AuthenticatedCampaignsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/$id/edit': {
      id: '/_authenticated/campaigns/$id/edit'
      path: '/campaigns/$id/edit'
      fullPath: '/campaigns/$id/edit'
      preLoaderRoute: typeof AuthenticatedCampaignsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/$id/$tab': {
      id: '/_authenticated/patients/$id/$tab'
      path: '/$tab'
      fullPath: '/patients/$id/$tab'
      preLoaderRoute: typeof AuthenticatedPatientsIdTabRouteImport
      parentRoute: typeof AuthenticatedPatientsIdRoute
    }
  }
}

interface AuthenticatedSetupRouteChildren {
  AuthenticatedSetupAppointmentTypesRoute: typeof AuthenticatedSetupAppointmentTypesRoute
  AuthenticatedSetupAssignmentRulesRoute: typeof AuthenticatedSetupAssignmentRulesRoute
  AuthenticatedSetupEntitiesRoute: typeof AuthenticatedSetupEntitiesRoute
  AuthenticatedSetupIntegrationsRoute: typeof AuthenticatedSetupIntegrationsRoute
  AuthenticatedSetupLabelsRoute: typeof AuthenticatedSetupLabelsRoute
  AuthenticatedSetupLocationsRoute: typeof AuthenticatedSetupLocationsRoute
  AuthenticatedSetupOrganizationRoute: typeof AuthenticatedSetupOrganizationRoute
  AuthenticatedSetupOutreachRoute: typeof AuthenticatedSetupOutreachRoute
  AuthenticatedSetupPayorsRoute: typeof AuthenticatedSetupPayorsRoute
  AuthenticatedSetupProvidersRoute: typeof AuthenticatedSetupProvidersRoute
  AuthenticatedSetupRolesRoute: typeof AuthenticatedSetupRolesRoute
  AuthenticatedSetupTeamsRoute: typeof AuthenticatedSetupTeamsRoute
  AuthenticatedSetupUsersRoute: typeof AuthenticatedSetupUsersRoute
  AuthenticatedSetupWorkflowsRoute: typeof AuthenticatedSetupWorkflowsRoute
}

const AuthenticatedSetupRouteChildren: AuthenticatedSetupRouteChildren = {
  AuthenticatedSetupAppointmentTypesRoute:
    AuthenticatedSetupAppointmentTypesRoute,
  AuthenticatedSetupAssignmentRulesRoute:
    AuthenticatedSetupAssignmentRulesRoute,
  AuthenticatedSetupEntitiesRoute: AuthenticatedSetupEntitiesRoute,
  AuthenticatedSetupIntegrationsRoute: AuthenticatedSetupIntegrationsRoute,
  AuthenticatedSetupLabelsRoute: AuthenticatedSetupLabelsRoute,
  AuthenticatedSetupLocationsRoute: AuthenticatedSetupLocationsRoute,
  AuthenticatedSetupOrganizationRoute: AuthenticatedSetupOrganizationRoute,
  AuthenticatedSetupOutreachRoute: AuthenticatedSetupOutreachRoute,
  AuthenticatedSetupPayorsRoute: AuthenticatedSetupPayorsRoute,
  AuthenticatedSetupProvidersRoute: AuthenticatedSetupProvidersRoute,
  AuthenticatedSetupRolesRoute: AuthenticatedSetupRolesRoute,
  AuthenticatedSetupTeamsRoute: AuthenticatedSetupTeamsRoute,
  AuthenticatedSetupUsersRoute: AuthenticatedSetupUsersRoute,
  AuthenticatedSetupWorkflowsRoute: AuthenticatedSetupWorkflowsRoute,
}

const AuthenticatedSetupRouteWithChildren =
  AuthenticatedSetupRoute._addFileChildren(AuthenticatedSetupRouteChildren)

interface AuthenticatedPatientsIdRouteChildren {
  AuthenticatedPatientsIdTabRoute: typeof AuthenticatedPatientsIdTabRoute
}

const AuthenticatedPatientsIdRouteChildren: AuthenticatedPatientsIdRouteChildren =
  {
    AuthenticatedPatientsIdTabRoute: AuthenticatedPatientsIdTabRoute,
  }

const AuthenticatedPatientsIdRouteWithChildren =
  AuthenticatedPatientsIdRoute._addFileChildren(
    AuthenticatedPatientsIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAppointmentsRoute: typeof AuthenticatedAppointmentsRoute
  AuthenticatedCallHistoryRoute: typeof AuthenticatedCallHistoryRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedFindSlotsRoute: typeof AuthenticatedFindSlotsRoute
  AuthenticatedLiveCallsRoute: typeof AuthenticatedLiveCallsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSetupRoute: typeof AuthenticatedSetupRouteWithChildren
  AuthenticatedVerifyPasskeyRoute: typeof AuthenticatedVerifyPasskeyRoute
  AuthenticatedWaitlistRoute: typeof AuthenticatedWaitlistRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedActivityInteractionIdRoute: typeof AuthenticatedActivityInteractionIdRoute
  AuthenticatedCallsLiveRoute: typeof AuthenticatedCallsLiveRoute
  AuthenticatedCampaignsNewRoute: typeof AuthenticatedCampaignsNewRoute
  AuthenticatedCampaignsRulesRoute: typeof AuthenticatedCampaignsRulesRoute
  AuthenticatedDocumentsIdRoute: typeof AuthenticatedDocumentsIdRoute
  AuthenticatedPatientsIdRoute: typeof AuthenticatedPatientsIdRouteWithChildren
  AuthenticatedSmsTestRoute: typeof AuthenticatedSmsTestRoute
  AuthenticatedTasksTaskIdRoute: typeof AuthenticatedTasksTaskIdRoute
  AuthenticatedActivityIndexRoute: typeof AuthenticatedActivityIndexRoute
  AuthenticatedCallsIndexRoute: typeof AuthenticatedCallsIndexRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
  AuthenticatedReferralsIndexRoute: typeof AuthenticatedReferralsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedCampaignsIdEditRoute: typeof AuthenticatedCampaignsIdEditRoute
  AuthenticatedCampaignsIdIndexRoute: typeof AuthenticatedCampaignsIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppointmentsRoute: AuthenticatedAppointmentsRoute,
  AuthenticatedCallHistoryRoute: AuthenticatedCallHistoryRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedFindSlotsRoute: AuthenticatedFindSlotsRoute,
  AuthenticatedLiveCallsRoute: AuthenticatedLiveCallsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSetupRoute: AuthenticatedSetupRouteWithChildren,
  AuthenticatedVerifyPasskeyRoute: AuthenticatedVerifyPasskeyRoute,
  AuthenticatedWaitlistRoute: AuthenticatedWaitlistRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedActivityInteractionIdRoute:
    AuthenticatedActivityInteractionIdRoute,
  AuthenticatedCallsLiveRoute: AuthenticatedCallsLiveRoute,
  AuthenticatedCampaignsNewRoute: AuthenticatedCampaignsNewRoute,
  AuthenticatedCampaignsRulesRoute: AuthenticatedCampaignsRulesRoute,
  AuthenticatedDocumentsIdRoute: AuthenticatedDocumentsIdRoute,
  AuthenticatedPatientsIdRoute: AuthenticatedPatientsIdRouteWithChildren,
  AuthenticatedSmsTestRoute: AuthenticatedSmsTestRoute,
  AuthenticatedTasksTaskIdRoute: AuthenticatedTasksTaskIdRoute,
  AuthenticatedActivityIndexRoute: AuthenticatedActivityIndexRoute,
  AuthenticatedCallsIndexRoute: AuthenticatedCallsIndexRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
  AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
  AuthenticatedReferralsIndexRoute: AuthenticatedReferralsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedCampaignsIdEditRoute: AuthenticatedCampaignsIdEditRoute,
  AuthenticatedCampaignsIdIndexRoute: AuthenticatedCampaignsIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface PlatformRouteChildren {
  PlatformAdminUsersRoute: typeof PlatformAdminUsersRoute
  PlatformOrganizationsRoute: typeof PlatformOrganizationsRoute
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformAdminUsersRoute: PlatformAdminUsersRoute,
  PlatformOrganizationsRoute: PlatformOrganizationsRoute,
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  CompleteProfileRoute: CompleteProfileRoute,
  PlatformRoute: PlatformRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
